/**
 * Enumeration of all available languages inside DS-Web.
 */
export enum DsLibLanguagesEnum {
  FRENCH = 'fr',
  ENGLISH = 'en',
  SPANISH = 'es',
  POLISH = 'pl',
  CZECH = 'cs',
}
